<template>
  <div class="voice-request-list-component">
    <div class="voice-request-list">
      <div class="voice-request-list-header">
        <p class="voice-request-list-title">{{ $t("voice.list.title") }}</p>
        <GrmCloseBtn small @click="onClickClose" />
      </div>
      <div class="voice-request-list-body">
        <perfect-scrollbar v-if="reqSpeakUserList.length > 0 || reqSpeakMsgList.length > 0">
          <ul class="voice-request-item-wrapper">
            <li class="voice-request-item" v-for="reqSpeakUser in reqSpeakUserList" :key="reqSpeakUser.userId">
              <div class="voice-request-item-text">
                <p class="voice-request-item-title">{{getUsername(reqSpeakUser.userId)}}</p>
                <p class="voice-request-item-time">{{reqSpeakUser.date}}</p>
              </div>
              <div class="voice-request-button-container">
                <button class="voice-request-button accept" @click="confirmRequestSpeak({reqSpeakId: reqSpeakUser.reqSpeakId, userId: reqSpeakUser.userId, reject:false})">{{ $t('common.apply') }}</button>
                <button class="voice-request-button refuse" @click="confirmRequestSpeak({reqSpeakId: reqSpeakUser.reqSpeakId, userId: reqSpeakUser.userId, reject:true})">{{ $t('common.reject') }}</button>
              </div>
            </li>
            <li class="voice-request-msg" v-for="reqSpeakMsg in reqSpeakMsgList" :key="reqSpeakMsg.userId">
              {{ reqSpeakMsg.msg }}
              <span class="voice-request-date">{{ reqSpeakMsg.date }}</span>
            </li>
          </ul>
        </perfect-scrollbar>
        <div class="voice-request-no-data" v-else>{{ $t("voice.list.notExist") }}</div>
      </div>
    </div>
  </div>
</template>

<script>

import {mapActions, mapGetters} from "vuex";
import moment from 'moment'
import GrmCloseBtn from "@/components/Common/button/GrmCloseBtn";

export default {
  name: "VoiceRequestList",
  components: {
    GrmCloseBtn
  },
  data() {
    return {
      reqSpeakUserList: [],
      reqSpeakMsgList: []
    }
  },
  created() {
    this.$roomApi.addEventListeners((this._Events = _Events()), this)
  },
  destroyed() {
    this.$roomApi.removeEventListeners(this._Events);
  },
  computed: {
    ...mapGetters('user', [
        'hasEmceeRole',
        'isMe',
        'getUsername'
    ])
  },
  methods: {
    ...mapActions('user', [
       'cancelRequestSpeak',
       'confirmRequestSpeak',
    ]),
    addReqSpeakUser(user) {
      let idx = this.reqSpeakUserList.findIndex(reqSpeakUser => reqSpeakUser.userId === user.userId);
      if(idx > -1) {
        this.reqSpeakUserList[idx] = user
      } else {
        this.reqSpeakUserList.push(user)
      }
    },
    removeReqSpeakUser(user) {
      let idx = this.reqSpeakUserList.findIndex(reqSpeakUser => reqSpeakUser.userId === user.userId);
      if(idx > -1) {
        this.reqSpeakUserList.splice(idx, 1)
      }
    },
    addRequestSpeakMsg(user) {
      if(!user) return;
      let userName = this.getUsername(user.userId);
      console.log('addRequestSpeakMsg', user);
      this.reqSpeakMsgList.unshift({
        msg: this.$t('voice.list.result', { '0': userName, '1': user.reject ? this.$t('common.reject'): this.$t('common.apply')}),
        date: user.date
      });
    },
    onClickClose() {
      this.$modal('VoiceRequestList')
    },
  }
}
function _Events(){
  return {
    room_user_requestSpeak: function(e) {
      const userId = e.userId,
          reqSpeakId = e.data.reqSpeakId;

      if(this.hasEmceeRole()){
        let date = moment(new Date()).format('HH:mm:ss')
        this.addReqSpeakUser({reqSpeakId, userId, date})
      }
    },
    room_user_cancelRequestSpeak: function(e) {
      const userId = e.userId,
          reqSpeakId = e.data.reqSpeakId;

      this.removeReqSpeakUser({reqSpeakId, userId})
    },
    room_user_confirmRequestSpeak: function(e) {
      const {reqUserId, reqSpeakId, reject} = e.data;
      if(this.hasEmceeRole()) {
        this.removeReqSpeakUser({reqSpeakId, userId : reqUserId})
        let date = moment(new Date()).format('HH:mm:ss')
        this.addRequestSpeakMsg({userId: reqUserId, reject, date})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.voice-request-list-component {
  position: absolute;
  top: 56px;
  right: 6px;
  z-index: 1;
}
.voice-request-list {
  width: 320px;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4);
  overflow: hidden;
}
.voice-request-list-header {
  height: 48px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  padding: 0 10px 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.voice-request-list-title {
  font-size: 14px;
  font-weight: 700;
  color: #333;
}
.voice-request-list-body {
  max-height: 200px;
  display: flex;
}
.voice-request-item-wrapper {}
.voice-request-item {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 12px 12px 12px 20px;
  display: flex;
  align-items: center;
}
.voice-request-item-title {
  font-size: 12px;
  line-height: 14px;
}
.voice-request-item-time {
  margin-top: 8px;
  font-size: 10px;
  color: #999;
}
.voice-request-item-text {
  flex: 1;
  min-width: 0;
  padding-right: 10px;
  display: flex;
  flex-direction: column;
}
.voice-request-button-container {
  align-self: stretch;
}
.voice-request-button {
  height: calc(100% + 24px);
  margin: -12px 0;
  padding: 0 10px;
  font-size: 12px;
  transition: 0.1s ease-out;
  &.accept {
    font-weight: 700;
    color: #59f;
    &:hover {
      background-color: #59f;
    }
  }
  &.refuse {
    color: #f05;
    &:hover {
      background-color: #f05;
    }
  }
  &:hover {
    color: #fff;
  }
}
.voice-request-msg {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 10px 20px 10px 20px;
  background-color: #f8f8f8;
  font-size: 12px;
  color: #999;
  display: flex;
  justify-content: space-between;
  align-self: center;
  gap: 8px;
}
.voice-request-date {
  font-size: 12px;
}
.voice-request-no-data {
  background-color: #eee;
  text-align: center;
  font-size: 14px;
  color: #aaa;
  line-height: 80px;
  width: 100%;
}
</style>